(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-general"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass('expanded');
    });
    $('.answer').slideUp(200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-questions"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass('expanded');
    });
    $('.answer').slideUp(200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
$(document).ready(function () {
	$('.js-footer-mob-heading').click(function (e) {
		e.preventDefault();
		var $clicked = $(this);

		$('.js-footer-mob-heading').each(function(){
			if ($(this).hasClass('footer-expanded') && $(this)[0] != $clicked[0] ) {
				$(this).next().slideToggle(200);
				$(this).toggleClass("footer-expanded");
				$(this).children('.plus-sign').toggleClass('collapsed');
			}
		});
		$(this).next().slideToggle(200);
		$(this).toggleClass("footer-expanded");
		return false;
	});

	function resizeHandler() {
		console.log("window resized");
		if ($(window).width() < 768) {
			console.log("the window is smaller than 768px");
			$('.footer-child-menu').slideUp(200);
		} else{
			$('.footer-child-menu').show(200);
			$('.footer-expanded').removeClass("footer-expanded");
		}
	}
	resizeHandler();
	$(window).resize(resizeHandler);
  
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-bundles-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  $('.contact-button').prop("disabled", false);
$('input:checkbox.checks').click(function() {
 if ($(this).is(':checked')) {
    $('.contact-button').prop("disabled", true);
 } else {
  if ($('.checks').filter(':checked').length < 1){
 	$('.contact-button').attr('disabled',false);}
 	}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-press"]) return;
  try {
    
  $(document).ready(function () {

      $('#showmore').click(function (e) {
		e.preventDefault();
        $(this).toggleClass("expanded");
        $(this).parent('.show-link-parent').next('.more-press-section').slideToggle(200);
		$('.show-link-parent-more').slideUp(200);
        $('.show-link-parent-less').slideDown(200);
        $('.show-link-parent-less').show();
      });

      $('#showless').click(function (e) {
		e.preventDefault();
        $(this).parent('.more-press-section').toggleClass("expanded");
		$('.show-link-parent-more').slideToggle(200);
		$('.show-link-parent-less').slideUp(200);
        $(this).parents('.more-press-section').slideUp(200);
      });

      $('.press-heading').click(function () {
        $(this).next('.press-links').slideToggle(200);
        $(this).toggleClass("expanded");
      });

      $('.press-links').hide();
      $('.press-links').slideUp(200);
      $('.more-press-section').slideUp(200);
      $('.more-press-section').hide();

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-subscription"]) return;
  try {
    
  $(document).ready(function () {
      $('.answer').hide();
      $('.question-heading').click(function () {
          $(this).next().slideToggle(200);
          $(this).toggleClass("expanded");

      });
      $('.answer').slideUp(200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-wholesale"]) return;
  try {
    
  $('.contact-button').prop("disabled", false);
$('input:checkbox.checks').click(function() {
 if ($(this).is(':checked')) {
    $('.contact-button').prop("disabled", true);
 } else {
  if ($('.checks').filter(':checked').length < 1){
 	$('.contact-button').attr('disabled',false);}
 	}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      // Re-initialize slider after AJAX content is loaded
      // Use setTimeout to ensure DOM is fully updated and jQuery is available
      setTimeout(function() {
        if (typeof initializeProductRecommendationsSlider === 'function') {
          initializeProductRecommendationsSlider();
        }
      }, 100);
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
    // Slider will be initialized in the AJAX callback
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
